// Okul modülü API sarmalayıcısı.
// Kendi bağımsız axios instance'ını kullanır: sabit baseURL + token'ı
// localStorage'dan okuyan request interceptor. common/auth.js'deki global
// interceptor'a bağımlı DEĞİLDİR (effect sırası yüzünden ilk render'da
// baseURL set edilmeden istek gidebiliyordu -> /school/school/list hatası).
import axios from "axios";
import API_URL from "../../config";

export const FILE_BASE = API_URL.replace(/\/$/, "");
export const fileUrl = (p) => (p ? `${FILE_BASE}${p}` : "");

const http = axios.create({
  baseURL: API_URL, // 'http://localhost:3001/'
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.token) config.headers.Authorization = `Bearer ${user.token}`;
  } catch (e) {
    /* localStorage yoksa sessiz geç */
  }
  return config;
});

const unwrap = (res) => (res.data && res.data.data !== undefined ? res.data.data : res.data);

const SchoolApi = {
  /* Okullar */
  listSchools: (q) => http.get("school/list", { params: q ? { q } : {} }).then(unwrap),
  getSchool: (id) => http.get(`school/${id}`).then(unwrap),
  createSchool: (body) => http.post("school", body).then(unwrap),
  updateSchool: (id, body) => http.post(`school/${id}/update`, body).then(unwrap),
  setSchoolRecording: (id, enabled) => http.post(`school/${id}/recording`, { enabled }).then(unwrap),
  deleteSchool: (id, force) =>
    http.get(`school/${id}/delete`, { params: force ? { force: 1 } : {} }).then(unwrap),

  /* Sınıf / Seviye */
  listGrades: (schoolId) => http.get(`school/${schoolId}/grades`).then(unwrap),
  createGrade: (schoolId, body) => http.post(`school/${schoolId}/grade`, body).then(unwrap),
  updateGrade: (gradeId, body) => http.post(`school/grade/${gradeId}/update`, body).then(unwrap),
  deleteGrade: (gradeId, force) =>
    http.get(`school/grade/${gradeId}/delete`, { params: force ? { force: 1 } : {} }).then(unwrap),

  /* Şube */
  listAllBranches: (schoolId) =>
    http.get("school/branches", { params: schoolId ? { school_id: schoolId } : {} }).then(unwrap),
  createBranch: (gradeId, body) => http.post(`school/grade/${gradeId}/branch`, body).then(unwrap),
  updateBranch: (branchId, body) => http.post(`school/branch/${branchId}/update`, body).then(unwrap),
  deleteBranch: (branchId, force) =>
    http.get(`school/branch/${branchId}/delete`, { params: force ? { force: 1 } : {} }).then(unwrap),

  /* Öğrenci atama */
  searchStudents: (q) => http.get("school/students/search", { params: { q } }).then(unwrap),
  listBranchStudents: (branchId) => http.get(`school/branch/${branchId}/students`).then(unwrap),
  // params: grade_id, branch_id, academic_year, q, page, page_size -> { rows, total, page, page_size, academic_years }
  listSchoolStudents: (schoolId, params) =>
    http.get(`school/${schoolId}/students`, { params }).then(unwrap),
  // emails: virgülle ayrılmış e-posta listesi (string) — backend tek tek e-postaları çözüp atar.
  assignStudents: (branchId, emails, academic_year) =>
    http.post(`school/branch/${branchId}/students`, { emails, academic_year }).then(unwrap),
  unassignStudent: (assignmentId) => http.get(`school/assignment/${assignmentId}/delete`).then(unwrap),

  /* Dosyalar */
  listFiles: (owner_type, owner_id) =>
    http.get("school/files", { params: { owner_type, owner_id } }).then(unwrap),
  uploadFile: (formData, onUploadProgress) =>
    // Content-Type'ı ELLE set etme; tarayıcı boundary ile birlikte kendisi ekler.
    http.post("school/files", formData, { onUploadProgress }).then(unwrap),
  deleteFile: (fileId) => http.get(`school/file/${fileId}/delete`).then(unwrap),
};

export default SchoolApi;
